
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuportePaisesStore from '@/components/Suporte/Store/SuportePaisesStore'

@Component
export default class ModalSuportePais extends Vue {
  $refs!: { paisForm: any }

  loadSaveOrUpdatePais: boolean = false
  get loadingSaveOrUpdatePais() { return this.loadSaveOrUpdatePais }
  set loadingSaveOrUpdatePais(value: boolean) { this.loadSaveOrUpdatePais = value }

  paisFormRules: any = {
    valid: true,
    hisId: [],
    // hisId: [(v: any) => !!v || 'Campo obrigatório.'],
    // mask: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  get getSuportePaisesStore() {
    return getModule(SuportePaisesStore, this.$store)
  }

  get showModalPais() { return this.getSuportePaisesStore.modal.pais }
  set showModalPais(value: boolean) { this.getSuportePaisesStore.setModal({ name: 'pais', value }) }

  async saveOrUpdatePais() {
    this.loadingSaveOrUpdatePais = true

    if (this.$refs.paisForm.validate()) {
      const response = await this.getSuportePaisesStore.upsertPaisHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Informações alteradas com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuportePaisesStore.getPaisAll()
        this.showModalPais = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar as informações ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdatePais = false
  }

  @Watch('showModalPais')
  onChangeShowModalPais(value: boolean) {
    if (!value) {
      this.$refs.paisForm.resetValidation()
      this.getSuportePaisesStore.clearPais()
    }
  }
}
